const SELECT_SHIPPING_METHOD = 'checkout/shipping/SELECT_SHIPPING_METHOD';
const SELECT_STORE = 'checkout/shipping/SELECT_STORE';
const SELECT_SERVICE_STORE = 'checkout/shipping/SELECT_SERVICE_STORE';
const SELECT_PICKUP_POINT = 'checkout/shipping/SELECT_PICKUP_POINT';
const SET_CONSENTS = 'checkout/shipping/SET_CONSENTS';
const TOGGLE_CONSENT = 'checkout/shipping/TOGGLE_CONSENT';
const TOGGLE_DELIVERY_ADDRESS = 'checkout/shipping/TOGGLE_DELIVERY_ADDRESS,';
const TOGGLE_IS_COMPANY = 'checkout/shipping/TOGGLE_IS_COMPANY';
const TOGGLE_INVOICE = 'checkout/shipping/TOGGLE_INVOICE';
const UPDATE_SHIPPING_DETAILS = 'checkout/shipping/UPDATE_SHIPPING_DETAILS';
const TOGGLE_PREFILL = 'checkout/shipping/TOGGLE_PREFILL';
const TOGGLE_PREFILL_SUCCESS = 'checkout/shipping/TOGGLE_PREFILL_SUCCESS';
const TOGGLE_PREFILL_FAILED = 'checkout/shipping/TOGGLE_PREFILL_FAILED';
const ADDRESS_BOOK_PREFILL_VALIDATION_FAILED = 'checkout/shipping/ADDRESS_BOOK_PREFILL_VALIDATION_FAILED';
const ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS = 'checkout/shipping/ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS';
const MARK_FIELDS_TOUCHED = 'checkout/shipping/MARK_FIELDS_TOUCHED';
const SET_MY_ACCOUNT_VALIDATION = 'checkout/shipping/SET_MY_ACCOUNT_VALIDATION';
const SET_SERVICE_STORE_VALIDATION = 'checkout/shipping/SET_SERVICE_STORE_VALIDATION';
const RESET_EXPRESS_CHECKOUT = 'checkout/shipping/RESET_EXPRESS_CHECKOUT';
const RESET_STORE = 'checkout/shipping/RESET_STORE';
const TOGGLE_EXPRESS_CHECKOUT = 'checkout/shipping/TOGGLE_EXPRESS_CHECKOUT';
const resetExpressCheckout = ()=>({
        type: RESET_EXPRESS_CHECKOUT
    })
;
const selectShippingMethod = (payload)=>({
        type: SELECT_SHIPPING_METHOD,
        payload
    })
;
const resetStore = ()=>({
        type: RESET_STORE
    })
;
const selectStore = (payload)=>({
        type: SELECT_STORE,
        payload
    })
;
const selectServiceStore = (payload)=>({
        type: SELECT_SERVICE_STORE,
        payload
    })
;
const selectPickupPoint = (payload)=>({
        type: SELECT_PICKUP_POINT,
        payload
    })
;
const toggleDeliveryAddress = (payload)=>({
        type: TOGGLE_DELIVERY_ADDRESS,
        payload
    })
;
const setConsents = (payload)=>({
        type: SET_CONSENTS,
        payload
    })
;
const toggleConsent = (payload)=>({
        type: TOGGLE_CONSENT,
        payload
    })
;
const toggleIsCompany = (payload)=>({
        type: TOGGLE_IS_COMPANY,
        payload
    })
;
const toggleInvoice = (payload)=>({
        type: TOGGLE_INVOICE,
        payload
    })
;
const toggleExpressCheckout = (payload)=>({
        type: TOGGLE_EXPRESS_CHECKOUT,
        payload
    })
;
const togglePrefill = (payload)=>{
    return {
        type: TOGGLE_PREFILL,
        payload
    };
};
const togglePrefillSuccess = (payload)=>({
        type: TOGGLE_PREFILL_SUCCESS,
        payload
    })
;
const togglePrefillFailed = (payload)=>({
        type: TOGGLE_PREFILL_FAILED,
        payload
    })
;
const addressBookPrefillValidationFailed = (payload)=>({
        type: ADDRESS_BOOK_PREFILL_VALIDATION_FAILED,
        payload
    })
;
const addressBookPrefillValidationSuccess = ()=>({
        type: ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS
    })
;
const updateShippingDetails = (payload)=>({
        type: UPDATE_SHIPPING_DETAILS,
        payload
    })
;
const markFieldsTouched = ()=>({
        type: MARK_FIELDS_TOUCHED
    })
;
const setMyAccountValidation = ()=>({
        type: SET_MY_ACCOUNT_VALIDATION
    })
;
const setServiceStoreValidation = ()=>({
        type: SET_SERVICE_STORE_VALIDATION
    })
;

export { ADDRESS_BOOK_PREFILL_VALIDATION_FAILED, ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS, MARK_FIELDS_TOUCHED, RESET_EXPRESS_CHECKOUT, RESET_STORE, SELECT_PICKUP_POINT, SELECT_SERVICE_STORE, SELECT_SHIPPING_METHOD, SELECT_STORE, SET_CONSENTS, SET_MY_ACCOUNT_VALIDATION, SET_SERVICE_STORE_VALIDATION, TOGGLE_CONSENT, TOGGLE_DELIVERY_ADDRESS, TOGGLE_EXPRESS_CHECKOUT, TOGGLE_INVOICE, TOGGLE_IS_COMPANY, TOGGLE_PREFILL, TOGGLE_PREFILL_FAILED, TOGGLE_PREFILL_SUCCESS, UPDATE_SHIPPING_DETAILS, addressBookPrefillValidationFailed, addressBookPrefillValidationSuccess, markFieldsTouched, resetExpressCheckout, resetStore, selectPickupPoint, selectServiceStore, selectShippingMethod, selectStore, setConsents, setMyAccountValidation, setServiceStoreValidation, toggleConsent, toggleDeliveryAddress, toggleExpressCheckout, toggleInvoice, toggleIsCompany, togglePrefill, togglePrefillFailed, togglePrefillSuccess, updateShippingDetails };
//# sourceMappingURL=actions.js.map
